// extracted by mini-css-extract-plugin
export default {"container":"tH-z","disabled":"uH-z","termsCheckbox":"vH-z","signUpButton":"wH-z","enrollingSpinner":"xH-z","learnMoreButton":"yH-z","buttonRow":"zH-z"};